/**
 * @file src/audio/syncBpmDisplaySource.js
 * @description The source tag the BPM display mirror writes `sync-bpm` with. Its own module (no
 * audio-stack imports) so lightweight consumers — the drive bridge's echo skip, the room write
 * gate's "this is a system repaint, not a tempo edit" check — can share the one identity without
 * pulling in the audio engine.
 */
export const SYNC_BPM_DISPLAY_SOURCE = { id: 'sync-bpm-display-mirror' };
